<script>
import filter from 'lodash/filter'
import map from 'lodash/map'
import { getToken } from '@utils/auth'

export default {
  props: {
    field_values: {
      type: Array,
      default: () => [],
    },
    forms: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    c_forms() {
      return map(this.forms, (form) => ({
        ...form,
        field_values: filter(this.field_values, { form_seq: form.seq }),
      }))
    },
  },
  methods: {
    map,
    getToken,
  },
}
</script>

<template>
  <div>
    <template v-for="form in c_forms">
      <h3 :key="`h3-${form.seq}`" :class="$style.xeAdmin">{{ form.title }}</h3>
      <div :key="`div-${form.seq}`" :class="$style.infoText">
        {{ form.description }}
      </div>
      <table
        :key="`table-${form.seq}`"
        cellspacing="0"
        cellpadding="0"
        :class="$style.rowTable"
      >
        <colgroup>
          <col width="200px" />
          <col width="*" />
        </colgroup>
        <tbody>
          <tr v-for="field_value in form.field_values" :key="field_value.seq">
            <th scope="row">
              <div>{{ field_value.title }}</div>
            </th>
            <td>
              <template
                v-if="
                  ['INPUT', 'TEXTAREA'].indexOf(field_value.field_type) !== -1
                "
              >
                {{ field_value.value }}
              </template>
              <template
                v-else-if="
                  ['SELECT', 'RADIO'].indexOf(field_value.field_type) !== -1
                "
              >
                {{ field_value.option_title }}
              </template>
              <template
                v-else-if="
                  ['MULTISELECT', 'CHECKBOX'].indexOf(
                    field_value.field_type
                  ) !== -1
                "
              >
                {{ map(field_value.options, ({ title }) => title).join(', ') }}
              </template>
              <template
                v-else-if="['FILE'].indexOf(field_value.field_type) !== -1"
              >
                <a
                  :href="
                    `/api/v1/admin/file/${
                      field_value.file_seq
                    }/download?access_token=${getToken()}`
                  "
                  >{{ field_value.source_filename }}</a
                >
              </template>
              <template v-else>
                <strong>ERROR</strong>
              </template>
            </td>
          </tr>
        </tbody>
      </table>
    </template>
  </div>
</template>

<style lang="scss" module>
@import '@src/design/default.scss';
@import '@src/design/admin.scss';
@import '@src/design/font.scss';
@import '@src/design/button.scss';
</style>
